import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Label } from '../components';
import cn from 'classnames';
import styles from './LandscapeBaseEditTemplate.module.css';

interface LandscapeBaseEditTemplateProps {
  children: React.ReactNode;
}

const LandscapeBaseEditTemplate: React.FC<LandscapeBaseEditTemplateProps> = ({
  children,
}) => {
  const navigate = useNavigate();
  // const { id } = useParams();
  // const location = useLocation();

  // const getPrimaryTabRoute = (path: string) => {
  //   const segments = path.split('/');
  //   return segments.slice(0, 5).join('/');
  // };

  // const primaryTabRoute = getPrimaryTabRoute(location.pathname);

  return (
    <div>
      <div className={cn(styles.heading)}>
        <Label content="Update Landscape" size="lg" />
        <Button
          className={styles.buttonLink}
          onClick={() => navigate('/landscapes')}
          variant="link"
        >
          Go back to overview
        </Button>
      </div>
      {/* <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={primaryTabRoute}
      >
        <TabItem
          title="Basic information"
          id={`/landscapes/edit/${id}/basic-information`}
        /> */}
      {/* <TabItem title="Landscape about" id={`/landscapes/edit/${id}/about`} /> */}
      {/* <TabItem title="Indicators" id={`/landscapes/edit/${id}/indicators`} />
        <TabItem title="Projects" id={`/landscapes/edit/${id}/projects`} />
        <TabItem
          title="Landscape updates"
          id={`/landscapes/edit/${id}/updates`}
        />
        <TabItem
          title="Commodities"
          id={`/landscapes/edit/${id}/commodities`}
        />
        <TabItem title="Documents" id={`/landscapes/edit/${id}/documents`} /> */}
      {/* </TabBar> */}
      <main>{children}</main>
    </div>
  );
};

export default LandscapeBaseEditTemplate;
